const shapes = {
  diamond: {
    start: 'polygon(50% 50%, 50% 50%, 50% 50%, 50% 50%)',
    end: 'polygon(50% -50%, 150% 50%, 50% 150%, -50% 50%)'
  },
  window: {
    start: 'inset(50% round 50% 50% 0% 0%)',
    end: 'inset(-20% round 50% 50% 0% 0%)'
  },
  rectangle: {
    start: 'inset(50%)',
    end: 'inset(0%)'
  },
  circle: {
    start: 'circle(0%)',
    end: 'circle(75%)'
  },
  ellipse: {
    start: 'ellipse(0% 0%)',
    end: 'ellipse(75% 75%)'
  }
};
export default function create(options) {
  const {
    shape = 'rectangle'
  } = options.namedEffect;
  const easing = options.easing || 'cubicInOut';
  const {
    start,
    end
  } = shapes[shape];
  return [{
    ...options,
    easing: 'quadOut',
    duration: options.duration * 0.8,
    keyframes: [{
      opacity: 0
    }, {
      opacity: 'var(--comp-opacity, 1)'
    }]
  }, {
    ...options,
    easing,
    keyframes: [{
      clipPath: start
    }, {
      clipPath: end
    }]
  }];

  /*
   * @keyframes <name>-fade{
   *   from {
   *     opacity: 0;
   *   }
   *   to {
   *     opacity: 1;
   *   }
   * }
   *
   * @keyframes <name>-clip {
   *   from {
   *     clip-path: <start>
   *   }
   *   to {
   *     clip-path: <end>
   *   }
   * }
   *
   * #target {
   *   animation: <name>-fade <duration * 0.8> <delay> quadOut backwards;
   *              <name>-clip <duration> <delay> <easing> backwards;
   * }
   */
}
//# sourceMappingURL=ShapeIn.js.map